import { createFileRoute } from '@tanstack/react-router';
import { AuditPage } from '@/features/audit/audit-page';
import { guardRoute } from '@/lib/route-guards';

export const Route = createFileRoute('/_app/admin/audit')({
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/admin/audit');
  },
  component: AuditPage,
});
